import CustomersPage from '@/pages/shared/CustomersPage'

export default function AdminCustomers() {
  return <CustomersPage basePath="/admin" canSuspend canAdjustWallet canSignInAs canSetTier canSetPassword />
}
